import React, { Component } from "react";
import {
  Card,
  Container,
  Row,
  Col,
  Button,
  Dropdown,
  Tooltip,
  OverlayTrigger,
  Form,
} from "react-bootstrap";
import CustomContentAlert, {
  routing_using_history,
  findBySearch,
  tableHeightScrollBars,
  scroolToTop,
} from "../helper";
import { connect } from "react-redux";
import isEqual from "lodash/isEqual";
import {
  CurrentPermitActions,
  APIResponseActions,
  SuperAdminAction,
} from "../../Actions";
import Loader from "../Loader/Loader";
import DataTable from "react-data-table-component";
import DatatableHeader from "../DatatableHeader/DatatableHeader";
import ConfirmModal from "../Modal/ConfirmCurrent-permit";
import moment from "moment";
import EditCurrentPermit from "../Modal/EditCurrentPermit";
import { saveAs } from "file-saver";
class CurrentPermit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _currentPermits: [],
      loader: false,
      deactivateLoader: false,
      filterdPermits: [],
      searchedPermits: [],
      permitType: "all",
      status: "current",
      showError: true,
      suite_id: "",
      propertyId: this.props.PropertyId,
      user_type: this.props.user_type,
      searchValue: "",
      isModalOpen: false,
      Id: "",
      call_when_here: "",
      show_modal: false,
      confirmDelete: false,
      show_alert: false,
      show_error_alert: true,
      api_success_message: "",
      api_error_message: "",
      arrAfter: [],
      temp_deactivation: true,
      permit_class: "",
      page: 1,
      Norow: 100,
      prevSearch: "",
      prevPage: "",
      prevNorow: "",
      selectedColumn: "created_at",
      asc: "false",
      sort_direction: "DESC",
      pageChanged: false,
      count: 0,
      findMore: false,
      beforeState: "",
      timezone: this.props.timezone,
      property: this.props.property,
      standard: "",
      visitor_current: "",
      visitor_future: "",
      modelOpen: false,
      finalTableHeight: 0,
      exportLink: false,
      listHeading: "current",
    };

    this.customStyles = {
      data: {
        style: {
          minHeight: "72px", // override the row height
        },
      },
      headCells: {
        style: {
          paddingLeft: "0", // override the cell padding for head cells
          paddingRight: "0",
        },
      },
      cells: {
        style: {
          paddingLeft: "0", // override the cell padding for data cells
          paddingRight: "0",
        },
      },
    };

    this.columns = [
      {
        name: "LPN",
        sortable: true,
        minWidth: "120px",
        maxWidth: "120px",
        selector: (row) => row?.lpn,
        cell: (row) => <div>{row?.lpn ? row?.lpn : "-"}</div>,
      },
      {
        name: "Begin Time",
        sortable: true,
        minWidth: "150px",
        selector: (row) => row?.begin_time,
        cell: (row) => <div>{row?.begin_time ? row.begin_time : "-"}</div>,
      },
      {
        name: "Expiry Time",
        sortable: true,
        minWidth: "150px",
        selector: (row) => row?.expire_time,
        cell: (row) => <div>{row?.expire_time ? row.expire_time : "-"}</div>,
      },
      {
        name: "Unit Id",
        sortable: true,
        cell: (row) => <div>{row?.suite_id ? row?.suite_id : "-"}</div>,
        selector: (row) => row?.suite_id,
      },
      {
        name: "Permit Class",
        sortable: true,
        cell: (row) => {
          return <div>{row?.permit_class ? row?.permit_class : "-"}</div>;
        },
        selector: (row) => row?.permit_class,
      },
      {
        name: "First Name",
        sortable: true,
        minWidth: "140px",
        cell: (row) => (
          <div>
            {" "}
            <OverlayTrigger
              delay={{ show: 250, hide: 400 }}
              placement={"top"}
              overlay={<Tooltip id={`tooltip-qw`}>{row?.first_name}</Tooltip>}
            >
              <div
                className="text-nowrap text-truncate pr-3"
                style={{ maxWidth: "140px" }}
              >
                {row?.first_name}
              </div>
            </OverlayTrigger>
          </div>
        ),
        selector: (row) => row?.first_name,
      },
      {
        name: "Last Name",
        sortable: true,
        minWidth: "140px",
        cell: (row) => (
          <div>
            <OverlayTrigger
              delay={{ show: 250, hide: 400 }}
              placement={"top"}
              overlay={<Tooltip id={`tooltip-qw`}>{row?.last_name}</Tooltip>}
            >
              <div
                className="text-nowrap text-truncate pr-3"
                style={{ maxWidth: "140px" }}
              >
                {row?.last_name}
              </div>
            </OverlayTrigger>
          </div>
        ),
        selector: (row) => row.last_name,
      },
      {
        name: "Phone",
        sortable: true,
        minWidth: "120px",
        cell: (row) => (
          <div className="text-nowrap">
            {row?.phone
              ? (row?.country_code || "") + row?.phone?.substring(0, 10)
              : "-"}
          </div>
        ),
        selector: (row) => row?.phone,
      },
      {
        name: "Status",
        sortable: true,
        minWidth: "80px",
        maxWidth: "80px",
        cell: (row) => (
          <div
            className={
              row.status.toLowerCase() === "active"
                ? "text-nowrap text-green"
                : "text-nowrap text-danger"
            }
          >
            {row?.status ? row?.status : "-"}
          </div>
        ),
        selector: (row) => row?.phone,
      },
      {
        name: "CWH",
        sortable: true,
        center: true,
        cell: (row) => {
          return (
            <div>
              <input
                type="checkbox"
                checked={row.call_when_here}
                onChange={() => {
                  this.handleCall_when_here_activate_deactive(row.id);
                }}
                disabled={
                  (this.props.user_type !== "superadmin" &&
                    this.props.user_type !== "admin") ||
                  row.status === "Inactive"
                }
              />
            </div>
          );
        },
        selector: (row) => row.call_when_here,
      },
      {
        name: "Deactivate",
        sortable: true,
        cell: (row) => {
          if (row.permit_class === "Visitor") {
            if (
              moment(row.begin_time).format("YYYY/MM/DD hh:mm:ss a") >
              moment().format("YYYY/MM/DD hh:mm:ss a")
            ) {
              return (
                <Button
                  className="btn-fill text-nowrap"
                  variant="danger"
                  size="xs"
                  disabled={row.status === "Inactive" || !row.active}
                  onClick={() => this.handleDeActivatePermit(row.id)}
                >
                  Deactivate
                </Button>
              );
            } else {
              return "Permit started";
            }
          } else {
            if (
              this.state.user_type === "admin" ||
              this.state.user_type === "superadmin"
            ) {
              return (
                <Button
                  className="btn-fill text-nowrap"
                  variant="danger"
                  size="xs"
                  disabled={row.status === "Inactive" || !row.active}
                  onClick={() => this.handleDeActivatePermit(row.id)}
                >
                  Deactivate
                </Button>
              );
            } else {
              return "Permit started";
            }
          }
        },
      },
      {
        name: "Action",
        width: "100px",
        cell: (row) => (
          <Dropdown>
            <Dropdown.Toggle
              variant="Primary"
              className="btn-xs"
              id="dropdown-basic"
              disabled={row.status === "Inactive"}
            >
              Action
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item href="" onClick={() => this.modelOpen(row)}>
                Edit Permit
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        ),
      },
    ];
    this.expandedComponent = ({ data }) => {
      return (
        <div className="extend-row">
          <Row className="expandedView mb-1">
            <Col>
              <Row>
                <Col xs="4">
                  <b>Email</b>
                </Col>
                <Col xs="8">
                  <OverlayTrigger
                    delay={{ show: 250, hide: 400 }}
                    placement={"top"}
                    overlay={<Tooltip id={`tooltip-qw`}>{data.email}</Tooltip>}
                  >
                    <span>{data.email}</span>
                  </OverlayTrigger>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col xs="4">
                  <b>Invited By</b>
                </Col>
                <Col xs="8">
                  <OverlayTrigger
                    delay={{ show: 250, hide: 400 }}
                    placement={"top"}
                    overlay={
                      <Tooltip id={`tooltip-qw`}>{data.resident_name}</Tooltip>
                    }
                  >
                    <span>{data.resident_name ? data.resident_name : "-"}</span>
                  </OverlayTrigger>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col xs="4">
                  <b>Fee</b>
                </Col>
                <Col xs="8">
                  <span>{data.fee ? data.fee : "-"}</span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="expandedView mb-1">
            <Col className="min-w-150px">
              <Row>
                <Col xs="4">
                  <b>Create Time</b>
                </Col>
                <Col xs="8">
                  <span>
                    {data.permit_created_at ? data.permit_created_at : "-"}
                  </span>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col xs="4">
                  <b>Invited Suite</b>
                </Col>
                <Col xs="8">
                  <span>{data.suite_id ? data.suite_id : "-"}</span>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col xs="4">
                  <b>Discount</b>
                </Col>
                <Col xs="8">
                  <span>
                    {data.discount_amount ? data.discount_amount : "-"}
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="expandedView mb-1">
            <Col>
              <Row>
                <Col xs="4">
                  <b>Permit Tag</b>
                </Col>
                <Col xs="8">
                  <span>{data.permit_tag ? data.permit_tag : "-"}</span>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col xs="4">
                  <b>Lot Name</b>
                </Col>
                <Col xs="8">
                  <OverlayTrigger
                    delay={{ show: 250, hide: 400 }}
                    placement={"top"}
                    overlay={
                      <Tooltip id={`tooltip-qw`}>
                        {data.lot_name ? data.lot_name : "-"}
                      </Tooltip>
                    }
                  >
                    <span>{data.lot_name ? data.lot_name : "-"}</span>
                  </OverlayTrigger>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col xs="4">
                  <b>Paid Amount</b>
                </Col>
                <Col xs="8">
                  <span>{data.paid_amount ? data.paid_amount : "-"}</span>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="expandedView mb-1">
            <Col>
              <Row>
                <Col xs="4">
                  <b>Stall Id</b>
                </Col>
                <Col xs="8">
                  <OverlayTrigger
                    delay={{ show: 250, hide: 400 }}
                    placement={"top"}
                    overlay={
                      <Tooltip id={`tooltip-qw`}>{data.stall_id}</Tooltip>
                    }
                  >
                    <span>{data.stall_id ? data.stall_id : "-"}</span>
                  </OverlayTrigger>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col xs="4">
                  <b>Group Id</b>
                </Col>
                <Col xs="8">
                  <OverlayTrigger
                    delay={{ show: 250, hide: 400 }}
                    placement={"top"}
                    overlay={
                      <Tooltip id={`tooltip-qw`}>{data.groupid}</Tooltip>
                    }
                  >
                    <span>{data.groupid ? data.groupid : "-"}</span>
                  </OverlayTrigger>
                </Col>
              </Row>
            </Col>
            <Col>
              <Row>
                <Col xs="4">
                  <b>Paid By</b>
                </Col>
                <Col xs="8">
                  <OverlayTrigger
                    delay={{ show: 250, hide: 400 }}
                    placement={"top"}
                    overlay={
                      <Tooltip id={`tooltip-qw`}>{data.groupid}</Tooltip>
                    }
                  >
                    <span>{data.payment_type ? data.payment_type : "-"}</span>
                  </OverlayTrigger>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="expandedView mb-1">
            <Col>
              <Row>
                <Col xs="4">
                  <b> Access Card/ Tag</b>
                </Col>
                <Col xs="8">
                  <span>{data.card_number ? data.card_number : "-"}</span>
                </Col>
              </Row>
            </Col>
            <Col></Col>
            <Col></Col>
          </Row>
        </div>
      );
    };
  }

  async componentDidMount() {
    const { user_type } = this.state;
    const selectedPropertyName = this.state.property?.property_name;
    const selectedDomainName = this.state.property?.domain;
    this.props.setDomainHeader(selectedPropertyName, selectedDomainName);
    if (this.props.location.search === "") {
      // for admin view all permits
      this.setState({ loader: true }, async () => {
        this.setState({ beforeState: this.state.permit_class });
        let suite_id = this.state.suite_id;
        if (this.props.permission_id === 2) {
          suite_id = this.props.suite_id;
          this.setState({
            suite_id: this.props.suite_id,
          });
        }
        const {
          page,
          Norow,
          searchValue,
          selectedColumn,
          sort_direction,
          permitType,
          status,
        } = this.state;
        const pageobj = {
          suite_id,
          user_type,
          permitType,
          status,
          page,
          Norow,
          searchValue,
          selectedColumn,
          sort_direction,
        };
        await this.props.fetchCurrentPermits(pageobj);
        this.setState({
          _currentPermits: JSON.parse(
            JSON.stringify(this.props.currentPermits.data)
          ),
          filterdPermits: JSON.parse(
            JSON.stringify(this.props.currentPermits.data)
          ),
          count: this.props.currentPermits.count,
          loader: false,
          showError: this.props.api_response,
          show_alert: false,
        });
      });
    } else {
      const { user_type: userType } = this.state;
      // for admin looking for resident
      const suite_id_ = this.props.location.search.split("?")[1]
        ? this.props.location.search.split("?")[1]
        : this.props.suite_id;
      this.setState({ loader: true, suite_id: suite_id_ }, async () => {
        this.setState({ beforeState: this.state.permit_class });
        const {
          page,
          Norow,
          searchValue,
          selectedColumn,
          sort_direction,
          permitType,
          status,
        } = this.state;
        const pageobj = {
          suite_id: suite_id_,
          userType,
          permitType,
          status,
          page,
          Norow,
          searchValue,
          selectedColumn,
          sort_direction,
        };
        await this.props.fetchCurrentPermits(pageobj);
        this.setState({
          _currentPermits: JSON.parse(
            JSON.stringify(this.props.currentPermits.data)
          ),
          count: this.props.currentPermits.count,
          filterdPermits: JSON.parse(
            JSON.stringify(this.props.currentPermits.data)
          ),
          loader: false,
          showError: this.props.api_response,
          show_alert: false,
        });
      });
    }
    const exportUrl = process.env.REACT_APP_CONFIG_BASE_URL;
    const height = tableHeightScrollBars();
    this.setState({
      finalTableHeight: height,
    });
    if (exportUrl) {
      this.setState({
        exportUrl: `${exportUrl}/api/v1/user/export_csv/${this.state.property.id}/permits`,
        newPermitUrl: `${exportUrl}/api/v1/user/export_csv/${this.state.property.id}/permits`,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.search !== prevProps.location.search) {
      this.setState({ suite_id: "" });
    }
    if (!isEqual(prevProps.currentPermits, this.props.currentPermits)) {
      this.setState(
        {
          _currentPermits: JSON.parse(
            JSON.stringify(this.props.currentPermits.data)
          ),
          filterdPermits: JSON.parse(
            JSON.stringify(this.props.currentPermits.data)
          ),
          count: this.props.currentPermits.count,
          showError: this.props.api_response,
          temp_deactivation: true,
        },
        () => {
          if (this.state.filterdPermits.length === 0) {
            this.setState({ page: 1 }, async () => {
              this.setState({
                filterdPermits: JSON.parse(
                  JSON.stringify(this.props.currentPermits.data)
                ),
                count: this.props.currentPermits.count,
              });
            });
          }
          if (this.state.searchValue?.length) {
            this.handleSearchChange(this.state.searchValue);
          }
        }
      );
    }
  }

  modelOpen = (row) => {
    this.setState({
      modelOpen: !this.state.modelOpen,
      permitData: row,
    });
  };

  exportUrlCall = () => {
    const unix_time = Math.round(new Date().getTime() / 1000);
    const current_time = unix_time - 14400;
    const { permitType, status, searchValue, exportUrl } = this.state;
    const newPermitUrl = `${exportUrl}/?permit_type=${permitType}&status=${status}&search=${searchValue}&current_time=${current_time}`;
    this.setState({
      newPermitUrl: newPermitUrl,
    });
  };

  handleDeActivatePermit = (permitId) => {
    this.setState({
      show_modal: true,
      Id: permitId,
      confirmDelete: true,
      isModalOpen: !this.state.isModalOpen,
      temp_deactivation: false,
    });
  };

  saveit = () => {
    const Id = this.state.Id;

    this.setState({ deactivateLoader: true }, async () => {
      await this.props.deActivatePermit(Id);
      if (this.props.api_response) {
        this.setState({
          show_alert: true,
          api_success_message: this.props.api_success_message,
          id: "",
          call_when_here: "",
          confirmDelete: false,
        });
      } else {
        this.setState({
          show_error_alert: false,
          Id: "",
          call_when_here: "",
          confirmDelete: false,
        });
      }
      this.setState({
        deactivateLoader: false,
        isModalOpen: !this.state.isModalOpen,
      });
      setTimeout(() => {
        this.setState({
          show_alert: false,
          temp_deactivation: true,
          show_error_alert: true,
        });
      }, 1500);
    });
  };

  handleSearchChange = ({ target }) => {
    const val = target ? target.value : this.state.searchValue;
    this.setState({
      prevSearch: this.state.searchValue,
      page: 1,
      pageChanged: true,
    });
    const columnList = [
      "lpn",
      "begin_time",
      "expire_time",
      "suite_id",
      "permit_class",
      "first_name",
      "last_name",
      "phone",
      "email",
      "permit_created_at",
      "permit_tag",
      "usage",
      "stall_id",
      "lot_name",
      "card_number",
    ];
    this.setState({ searchValue: val }, () => {
      if (this.state.searchValue.length) {
        this.exportUrlCall();
        const { searchValue } = this.state;
        if (!this.state.findMore) {
          this.setState(
            {
              pageChanged: true,
              filterdPermits: findBySearch(
                searchValue,
                this.state._currentPermits,
                this.state._currentPermits,
                columnList,
                this.props.timezone
              ),
            },
            () => {
              this.setState({ count: this.state.filterdPermits.length });
            }
          );
        }
        this.setState({
          searchValue,
        });
      } else {
        this.setState({
          _currentPermits: this.state._currentPermits,
          count: this.state._currentPermits.length,
          filterdPermits: [],
        });
      }
    });
  };

  handleCall_when_here_activate_deactive = async (id) => {
    await this.props.call_when_here_activate_deactive(id);
    this.setState({
      Id: id,
    });
    if (this.props.api_response) {
      this.setState({
        show_alert: true,
        api_success_message: this.props.api_success_message,
      });
    } else {
      this.setState({
        show_error_alert: false,
        api_error_message: "CWH did not change",
      });
    }
    setTimeout(() => {
      this.setState({ show_alert: false, show_error_alert: true });
    }, 2000);
  };

  handleBack = () => {
    routing_using_history(`/units`);
  };

  datatableHandle = (
    searchValue,
    currentPermits,
    filterdPermits
    // pageChanged
  ) => {
    return (
      <>
        <DataTable
          data={
            searchValue && searchValue.length ? filterdPermits : currentPermits
          }
          columns={this.columns}
          customStyles={this.customStyles}
          expandableRows
          expandableRowsComponent={this.expandedComponent}
          responsive={true}
          // subHeader
          onChangePage={scroolToTop}
          defaultSortAsc={false}
          fixedHeader={true}
          fixedHeaderScrollHeight={this.state.finalTableHeight}
          pagination={true}
          paginationPerPage={this.state.Norow}
          paginationTotalRows={this.state.count}
          paginationRowsPerPageOptions={[100, 200, 300, 400]}
        />
      </>
    );
  };

  CloseModal() {
    this.setState({ modelOpen: false });
  }

  hideSlider = () => {
    document.body.classList.remove("foc-open");
  };

  handleFilterChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  resetPermitFilters = () => {
    this.setState({
      permitType: "all",
      status: "current",
    });
  };

  handleSearch = async () => {
    this.setState({ loader: true }, async () => {
      const {
        page,
        Norow,
        searchValue,
        selectedColumn,
        sort_direction,
        permitType,
        status,
        suite_id,
        user_type,
      } = this.state;
      const pageObj = {
        suite_id,
        user_type,
        permitType,
        status,
        page,
        Norow,
        searchValue,
        selectedColumn,
        sort_direction,
      };
      pageObj.exportLink = false;
      await this.props.fetchCurrentPermits(pageObj);
      this.setState({ loader: false, listHeading: status });
      document.body.classList.remove("foc-open");
    });
  };

  exportPemrits = () => {
    this.setState({ loader: true }, async () => {
      const {
        page,
        Norow,
        searchValue,
        selectedColumn,
        sort_direction,
        permitType,
        status,
        suite_id,
        user_type,
        property,
      } = this.state;
      const pageObj = {
        suite_id,
        user_type,
        permitType,
        status,
        page,
        Norow,
        searchValue,
        selectedColumn,
        sort_direction,
      };
      pageObj.exportLink = true;
      const bufferData = await this.props.fetchCurrentPermits(pageObj);
      const currentTimeDate = moment().format("YYYYMMDD-hhmmss");
      const exportDataName = `PERMITS-${currentTimeDate}-${property?.domain}.xls`;
      if (bufferData) {
        saveAs(
          new Blob([bufferData], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          }),
          exportDataName
        );
      }

      this.setState({ loader: false });
    });
  };

  render() {
    const {
      permitType,
      status,
      loader,
      isModalOpen,
      confirmDelete,
      show_alert,
      show_error_alert,
      api_success_message,
      api_error_message,
      searchValue,
      filterdPermits,
      _currentPermits,
      page,
      Norow,
      pageChanged,
      modelOpen,
      listHeading,
    } = this.state;
    const history = require("../../history").default;
    return (
      <div>
        <Container fluid>
          <Row>
            <Col md="12">
              <Card className="mb-0">
                <Card.Body className="pos-rel-overflow-hide">
                  <>
                    {show_alert && (
                      <CustomContentAlert
                        delay={2000}
                        message={api_success_message}
                        className="toast-success"
                      />
                    )}
                    {!show_error_alert && (
                      <CustomContentAlert
                        delay={2000}
                        message={api_error_message}
                        className="toast-error"
                      />
                    )}
                    <div className="sidebarFilter">
                      <Card className="contact-container mb-0">
                        <Card.Header
                          style={{ backgroundColor: this.props.main_body }}
                        >
                          <div className="d-flex align-items-center justify-content-between">
                            <Card.Title as="h4">
                              {`List of ${listHeading} Permit`}
                            </Card.Title>
                            <a
                              onClick={this.hideSlider}
                              href="javascript:void(0);"
                              className="btn btn-sm border-0 bg-light rounded-circle  w-30px h-30px d-flex align-items-center justify-content-center"
                            >
                              <i className="fa fa-times" aria-hidden="true"></i>
                            </a>
                          </div>
                        </Card.Header>
                        <Card.Body>
                          <Row>
                            <Col md="12">
                              <Form.Group controlId="exampleForm.ControlSelect1">
                                <Form.Label>PERMIT TYPE:</Form.Label>
                                <Form.Control
                                  as="select"
                                  name="permitType"
                                  value={permitType}
                                  onChange={this.handleFilterChange}
                                  placeholder="Select Permit Type"
                                >
                                  <option value="all">All</option>
                                  <option value="Resident">Standard</option>
                                  <option value="Visitor">Visitor</option>
                                  <option value="PassagePass">
                                    Passage Pass
                                  </option>
                                  <option value="Kiosk">Kiosk</option>
                                  <option value="Grace">Grace</option>
                                  {/* <option disabled value="Validation">
                                    Validation
                                  </option> */}
                                  {/* <option disabled value="Events">Events</option>
                                  <option disabled value="Carpool">Carpool</option>
                                  <option disabled value="Group">Group</option> */}
                                  {/* <option disabled value="Employee">Employee</option> */}
                                  {/* <option disabled value="Administrative">Administrative</option> */}
                                  {/* <option disabled value="Transient">Transient</option> */}
                                  {/* <option disabled value="ExternalOwner">ExternalOwner</option> */}
                                </Form.Control>
                              </Form.Group>
                            </Col>
                            <Col md="12">
                              <Form.Group controlId="exampleForm.ControlSelect1">
                                <Form.Label>STATUS:</Form.Label>
                                <Form.Control
                                  as="select"
                                  name="status"
                                  value={status}
                                  onChange={this.handleFilterChange}
                                  placeholder="Select Status"
                                >
                                  <option value="current">Current</option>
                                  <option value="future">Future</option>
                                  <option value="deactivated">
                                    {`Deactivated (past 30 days)`}
                                  </option>
                                </Form.Control>
                              </Form.Group>
                            </Col>
                          </Row>
                        </Card.Body>
                        <Card.Footer className="text-right justify-content-between d-flex">
                          <Button
                            variant="info"
                            className="h-40 custom-btn-secondary btn-sm"
                            onClick={this.resetPermitFilters}
                            disabled={loader}
                          >
                            Reset
                          </Button>
                          <Button
                            variant="info"
                            className="h-40 btn-fill btn-sm ml-2"
                            onClick={this.handleSearch}
                            disabled={loader}
                          >
                            Search
                          </Button>
                        </Card.Footer>
                      </Card>
                    </div>
                    <header>
                      <div className="active-permit-header sm-flex-column sm-align-items-start">
                        <div className="d-flex align-items-center">
                          {history.location.search ? (
                            <span
                              onClick={this.handleBack}
                              className="text-primary fs-13px btn btn-sm bg-light border-0 mr-2 h-30px"
                            >
                              <i
                                className="fa fa-chevron-left"
                                aria-hidden="true"
                              ></i>{" "}
                              Back
                            </span>
                          ) : null}
                          <h5 className="mb-2 mb-md-0">
                            {`List of ${listHeading} Permit`}
                          </h5>
                        </div>
                        {/* <Row className="align-items-center"> */}
                        {/* </Row> */}
                        <div className="filter-button d-flex flex-wrap">
                          <div className="d-flex align-items-center search-mb-0">
                            <DatatableHeader
                              className="mt-0 mb-0"
                              searchValue={this.state.searchValue}
                              HandleChange={this.handleSearchChange}
                            />
                            {this.state.filterdPermits.length ||
                            this.state._currentPermits.length > 0 ? (
                              <div className="ml-2">
                                {/* <a
                                  href={this.state.newPermitUrl}
                                  target="_blank"
                                  rel="noreferrer"
                                  className="btn-fill btn-sm btn btn-info btn-medium"
                                > */}
                                <span
                                  onClick={this.exportPemrits}
                                  className="btn-fill btn-sm btn btn-info btn-medium"
                                >
                                  Export
                                </span>
                                {/* </a> */}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </header>
                  </>
                  {loader ? (
                    <Loader />
                  ) : (
                    <>
                      {/* {(_currentPermits || filterdPermits) && (
                        <> */}
                      <div className="citation-list-table view-all-permit-table">
                        {this.datatableHandle(
                          searchValue,
                          _currentPermits,
                          filterdPermits,
                          page,
                          Norow,
                          pageChanged
                        )}
                      </div>
                      {/* </>
                      )} */}
                    </>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
        {modelOpen && (
          <EditCurrentPermit
            closeModal={this.CloseModal.bind(this)}
            modelOpen={modelOpen}
            updatePermit={this.updatePermit}
            permitData={this.state.permitData}
            status={status}
          />
        )}

        <ConfirmModal
          showBrowserModal={isModalOpen}
          deactivateLoader={this.state.deactivateLoader}
          closeModal={() =>
            this.setState({
              isModalOpen: !this.state.isModalOpen,
              Id: "",
              call_when_here: "",
              confirmDelete: false,
            })
          }
          {...(confirmDelete && {
            deActivatePermit: this.handleDeActivatePermit,
            Id: this.state.Id,
            saveit: this.saveit,
          })}
        />
      </div>
    );
  }
}

const mapStateToProps = ({
  CurrentPermitDetails,
  APIResponseDetails,
  UserProfileDetails,
  Logindetails,
}) => {
  const { currentPermits } = CurrentPermitDetails;
  const { api_response, api_error_message, api_success_message } =
    APIResponseDetails;
  const { suite_id, PropertyId, user_type, timezone, property, permission_id } =
    UserProfileDetails;
  const { backgroundColor } = Logindetails;
  const { MainBackground: main_body } = backgroundColor;
  return {
    currentPermits,
    api_response,
    api_error_message,
    suite_id,
    PropertyId,
    user_type,
    api_success_message,
    timezone,
    property,
    main_body,
    permission_id,
  };
};

const mapStateToDispatch = {
  fetchCurrentPermits: CurrentPermitActions.fetchCurrentPermits,
  APIResponseSuccess: APIResponseActions.APIResponseSuccess,
  deActivatePermit: CurrentPermitActions.deActivatePermit,
  call_when_here_activate_deactive:
    CurrentPermitActions.call_when_here_activate_deactive,
  setDomainHeader: SuperAdminAction.setDomainHeader,
};

export default connect(mapStateToProps, mapStateToDispatch)(CurrentPermit);
